import React from "react";
import "./banner_homepage.css";

const Banner = () => {
  return (
    <div className="banner">
      <div className="banner-image"></div>
    </div>
  );
};

export default Banner;